<template>

  <footer class="footer mt-5 footer-whidth">
    <div class="container">
      <div class="row">
        <div class="col">
        </div>
        <div class="col text-center">
          <p>
            <i class="bi bi-cc-circle"></i>
<!--            Show the current year-->
            {{ currentYear }}
            <router-link class="link-footer" to="/">Link Curt</router-link>
          </p>
        </div>
        <div class="col">
        </div>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'FooterComponent',
  /**
   * Provides the data object for the component.
   *
   * @return {Object} Returns an object containing the current year.
   */
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};

</script>

<style scoped>
.footer-whidth{
  max-width: 75dvw;
  margin: auto;
}

.link-footer{
  color: inherit;
  text-decoration: none;
}
</style>
